export const parseRewards = (r) => {
    if (!r) return [];
    if (Array.isArray(r)) return r;
    try {
        return JSON.parse(r);
    } catch {
        return [];
    }
};
